HModalComponent.$inject = ['$scope', '$element', '$compile'];

function HModalComponent($scope, $element, $compile) {
    var self = this;

    self.$onInit = function () {
        var selector = "<" + self.modalData.modalOptions.component + " " +
            "[on-save]=$ctrl.onSave " +
            "[on-delete]=$ctrl.onDelete " +
            "[modal-Data]=$ctrl.modalData " +
            "(close)=$ctrl.close() " +
            " ></" + self.modalData.component + ">";
        $element.find('.modal-wrapper').html($compile(selector)($scope));
    };
}

angular
    .module('harriApp')
    .component("hModalComponent", {
        bindings: {
            onViewLoaded: '&',
            modalData: '=',
            onSave: '&',
            onDelete: '&',
            close: '&',
        },
        controller: HModalComponent,
        controllerAs: '$ctrl',
        template: '<div class="modal-wrapper"></div>'
    });